export const env = {
  ENV: 'PRODUCTION',
  API_BASE_URL: 'https://api.zetapp.in/',
  CMS_API_BASE_URL: 'https://api.zetapp.in/',
  // MIXPANEL_TOKEN: 'f2f1fc9648ec523e6247c0a4698d1cb6',
  MIXPANEL_TOKEN: '',
  MIXPANEL_ENABLE: false,
  MOENGAGE_ENABLE: true,
  FIREBASE_PERF_ENABLE: true,
  IS_EVENTS_ENABLED: true,
  FRESHCHAT_APP_ID: 'a60d8d70-c9f9-4946-8faf-ef645b69cd29',
  FRESHCHAT_APP_KEY: 'a9068cdc-b536-4654-ad3d-f16b66fe3e62',
  MOENGAGE_APP_ID: 'HP1GOPZMUQAOCHEL2Z970JTI',
  AUGMONT_SILVER_URL:
    'https://zet.augmont.com/buy?utm_source=onecode&utm_medium=onecode&utm_campaign=',
  APP_BUILD_ENV: 'ZET',
  SENTRY_DSN:
    'https://03dc9f06067a42199392fbb40a9ce34e@o4504554019028992.ingest.sentry.io/4504711695761408',
  FRESHDESK_DISPUTE_URL:
    'https://onecode-asset.s3.ap-south-1.amazonaws.com/prod/raiseDispute.html',
  WEB_SOCKET_BASE_URL: 'wss://setu.zetapp.in',
  MOENGAGE_CLUSTER: 'DC_3',
  VRM_WEB_SOCKET_BASE_URL: 'wss://api.zetapp.in',
  CHOICE_CONNECT_WIDGET_URL: 'https://motor.choiceinsurance.in/',
  CHOICE_CONNECT_AGENT_CODE: 'C0039207',
  EASEBUZZ_PAYMENT_MODE: 'production',
} as const
